interface Props {
  time?: string;
  city?: string;
}

export function MaTimePill({ time, city = "AMS" }: Props) {
  const display = time ?? new Date().toTimeString().slice(0, 5);
  return (
    <div style={{
      display: "inline-flex", alignItems: "center", gap: 8,
      padding: "6px 10px", background: "var(--ma-ink)", color: "var(--ma-paper)",
      fontFamily: "var(--ma-mono)", fontSize: 11, letterSpacing: "0.06em",
    }}>
      <span className="ma-pulse-dot" style={{ background: "var(--ma-paper)" }} />
      <span>{city} · {display}</span>
    </div>
  );
}
